export const presets = [
  // weekend getaway
  [
    { description: "shirts", quantity: 3, packed: false, id: Date.now() },
    {
      description: "pants",
      quantity: 3,
      packed: false,
      id: Date.now() + 0.001,
    },
    {
      description: "pairs of underwear",
      quantity: 3,
      packed: false,
      id: Date.now() + 0.002,
    },
    {
      description: "pairs of socks",
      quantity: 3,
      packed: false,
      id: Date.now() + 0.003,
    },
    {
      description: "pajama shirts",
      quantity: 2,
      packed: false,
      id: Date.now() + 0.004,
    },
    {
      description: "pajama pants",
      quantity: 2,
      packed: false,
      id: Date.now() + 0.005,
    },
    {
      description: "swimwear",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.006,
    },
    {
      description: "deodorant",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.007,
    },
    {
      description: "toothbrush",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.008,
    },
    {
      description: "toothpaste",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.009,
    },
    {
      description: "hairbrush",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.01,
    },
  ],

  // 4-night camping trip
  [
    { description: "shirts", quantity: 5, packed: false, id: Date.now() },
    {
      description: "pants",
      quantity: 5,
      packed: false,
      id: Date.now() + 0.001,
    },
    {
      description: "pairs of underwear",
      quantity: 5,
      packed: false,
      id: Date.now() + 0.002,
    },
    {
      description: "pairs of socks",
      quantity: 5,
      packed: false,
      id: Date.now() + 0.003,
    },
    {
      description: "pajama shirts",
      quantity: 4,
      packed: false,
      id: Date.now() + 0.004,
    },
    {
      description: "pajama pants",
      quantity: 4,
      packed: false,
      id: Date.now() + 0.005,
    },
    {
      description: "swimwear",
      quantity: 2,
      packed: false,
      id: Date.now() + 0.006,
    },
    {
      description: "deodorant",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.007,
    },
    {
      description: "toothbrush",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.008,
    },
    {
      description: "toothpaste",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.009,
    },
    {
      description: "hairbrush",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.01,
    },
    {
      description: "tent",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.011,
    },
    {
      description: "sleeping bag",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.012,
    },
    {
      description: "flashlight",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.013,
    },
    {
      description: "pack of batteries",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.014,
    },
    {
      description: "camp chair",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.015,
    },
    {
      description: "multi-tool",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.016,
    },
    {
      description: "duct tape",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.017,
    },
    {
      description: "saw/axe",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.018,
    },
    {
      description: "stove",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.019,
    },
    {
      description: "container of fuel",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.02,
    },
    {
      description: "cooking pot",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.021,
    },
    {
      description: "frying pan",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.022,
    },
    {
      description: "eating utensils",
      quantity: 5,
      packed: false,
      id: Date.now() + 0.023,
    },
    {
      description: "cooking utensils",
      quantity: 5,
      packed: false,
      id: Date.now() + 0.024,
    },
    {
      description: "can opener",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.025,
    },
    {
      description: "knife",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.026,
    },
    {
      description: "cups",
      quantity: 3,
      packed: false,
      id: Date.now() + 0.027,
    },
    {
      description: "cutting board",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.028,
    },
    {
      description: "cooler",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.029,
    },
    {
      description: "bag of ice",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.03,
    },
    {
      description: "biodegradable soap",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.031,
    },
    {
      description: "trash bags",
      quantity: 2,
      packed: false,
      id: Date.now() + 0.032,
    },
    {
      description: "dish towel",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.033,
    },
    {
      description: "roll of toilet paper",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.034,
    },
    {
      description: "hand sanitizer",
      quantity: 1,
      packed: false,
      id: Date.now() + 0.035,
    },
  ],
];
